import { LayoutService } from './../../services/layout.service';
import { Component, OnInit, Input, EventEmitter, Output, ViewChild, ElementRef, AfterViewInit, Renderer2, group } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import { MenuService } from '../../services/menu.service';
import {
    trigger,
    state,
    style,
    animate,
    transition
  } from '@angular/animations';
import { slideToRight } from '../../animations/router.animation';
import intersection from 'lodash-es/intersection';
export class SidenavComponent implements OnInit, AfterViewInit {

       nav: any = false;
       lazyLoadModule: any = false;
       navFromRouter: any;
       lazyLoadPath: string;
       pageTitle = new EventEmitter();
      moduleConfig: any;
       opened = true;
      sidenavClass = {
          minimize: false
      };
/**
 * @param {?} render
 * @param {?} ref
 * @param {?} router
 * @param {?} activeRoute
 * @param {?} menuService
 * @param {?} layoutService
 */
constructor(
private render: Renderer2,
private ref: ElementRef,
private router: Router,
private activeRoute: ActivatedRoute,
private menuService: MenuService,
public layoutService: LayoutService
      ) { }
/**
 * @return {?}
 */
ngOnInit() {
            if (this.nav === false) {
                  this.menuService.sidenav.subscribe(res => this.navFromRouter = res);
            }
            this.layoutService.sidebarOpen.subscribe((open) => {
                this.sidenavClass.minimize = !open;
            });
            console.log(this.nav);
      }
/**
 * @return {?}
 */
ngAfterViewInit() {
          const /** @type {?} */ content = this.ref.nativeElement.querySelector('.mat-sidenav-content');
          this.layoutService.sidebarOpen.subscribe((open) => {
              this.render.addClass(content, 'animate-content');
              if (open) {
                  this.render.setStyle(content, 'margin-left', '255px');
              } else {
                  this.render.setStyle(content, 'margin-left', '70px');
              }
          });
      }
/**
 * @param {?} i
 * @return {?}
 */
parentOpen(i: any) {
            if (this.nav === false) {
                  if (this.navFromRouter[i].isOpen === false || !this.navFromRouter[i].hasOwnProperty('isOpen')) {
                        this.navFromRouter[i].isOpen = true;
                  } else {
                        this.navFromRouter[i].isOpen = false;
                  }
            } else {
                  if (this.nav[i].isOpen === false || !this.nav[i].hasOwnProperty('isOpen')) {
                        this.nav[i].isOpen = true;
                  } else {
                        this.nav[i].isOpen = false;
                  }
            }
      }
/**
 * @param {?} instruction
 * @return {?}
 */
isActive(instruction: any[]): boolean {
            return this.router.isActive(this.router.createUrlTree(instruction), false);
      }
/**
 * @param {?} level
 * @return {?}
 */
childrenAndActive(level) {
        if (level.children && level.children.length > 0 && (level.isOpen || this.isActive([level.path]))) {
            return true;
        }else {
            return false;
        }
      }
/**
 * @param {?} level
 * @return {?}
 */
toggleChildren(level) {
        if (level.children && level.children.length > 0 && (level.isOpen || this.isActive([level.path]))) {
            return 'active';
        }else {
            return 'inactive';
        }
      }
/**
 * @param {?} row
 * @return {?}
 */
checkPath(row) {
            if (row.path === '') {
                  return { exact: true };
            } else {
                  return { exact: false };
            }
      }
/**
 * @return {?}
 */
toggle() {
        this.opened = !this.opened;
    }
/**
 * @param {?} navItem
 * @return {?}
 */
checkHidden(navItem) {
        let /** @type {?} */ hidden = false;
        if (navItem.hasOwnProperty('redirectTo')) {
                hidden = true;
        } else {
                if (navItem.hasOwnProperty('data')) {
                    if (navItem.data.hasOwnProperty('hidden')) {
                            hidden = navItem.data.hidden;
                    }
                }
        }
        return hidden;
    }
/**
 * @param {?} item
 * @return {?}
 */
setPageToolbar(item) {
        this.pageTitle.emit(item.name);
    }
/**
 * @param {?} menu
 * @param {?=} asal
 * @return {?}
 */
checkGroupAccess(menu, asal = '') {
        if (menu && menu.data && menu.data.groupAccess.permissions && menu.data.groupAccess.groups) {
            const /** @type {?} */ allowed = intersection(menu.data.groupAccess.permissions, menu.data.groupAccess.groups).length > 0 ? true : false;
            if (allowed) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
      selector: 'hd-sidenav',
      template: `
        <mat-sidenav-container>
                <mat-sidenav #sidenav
                    fixedInViewport='true'
                    fixedTopGap='70'
                    opened="true" 
                    mode='side' 
                    class="m-grid__item m-aside-left m-aside-left--skin-dark" 
                    [ngClass]="sidenavClass"
                    [@slideToRight]="">
                    <div id="m_ver_menu" class="m-aside-menu m-aside-menu--skin-dark m-aside-menu--submenu-skin-dark" data-menu-vertical="true" data-menu-scrollable="false" data-menu-dropdown-timeout="500">
                        <ul *ngIf="nav === false; else fromVar" class="m-menu__nav  m-menu__nav--dropdown-submenu-arrow">
                            <ng-template ngFor let-level1 [ngForOf]="navFromRouter" let-i="index">
                                    <ng-template [ngIf]="checkHidden(level1) === false && checkGroupAccess(level1)">
                                        <li hd-sidenav-item cdk-overlay-origin
                                            class="m-menu__item" 
                                            routerLinkActive="m-menu__item--active"
                                            routerLinkActiveOptions="{ exact: true }" 
                                            aria-haspopup="true"
                                            [ngClass]="{'m-menu__item--open':childrenAndActive(level1)}"
                                            [menu]='level1' 
                                            [nav]='nav' 
                                            [navFromRouter]='navFromRouter' 
                                            [index]='i'
                                            [sidenavOpen]='sidenavClass'>
                                        </li>
                                    </ng-template>
                            </ng-template>
                        </ul>
                        <ng-template #fromVar>
                            <ng-template ngFor let-level1 [ngForOf]="nav" let-i="index">
                                <ng-template [ngIf]="checkHidden(level1) === false && checkGroupAccess(level1)">
                                    <li hd-sidenav-item cdk-overlay-origin class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{ exact: true }"
                                        aria-haspopup="true" [ngClass]="{'m-menu__item--open':childrenAndActive(level1)}" [menu]='level1' [nav]='nav' [index]='i'
                                        [sidenavOpen]='sidenavClass'>
                                    </li>
                                </ng-template>
                            </ng-template>
                        </ng-template>
                        </div>
                </mat-sidenav>
                <ng-content></ng-content>
        </mat-sidenav-container>
      `,
      styles: [`
        mat-sidenav-container {
          background: #f2f3f8;
          position: fixed;
          overflow: visible; }

        .m-aside-left.m-aside-left--skin-dark {
          background-color: #2c2e3e; }

        .m-aside-menu .m-menu__nav {
          list-style: none;
          padding: 30px 0 30px 0; }

        dl, ol, ul {
          margin-top: 0;
          margin-bottom: 1rem; }

        *, ::after, ::before {
          -webkit-box-sizing: inherit;
                  box-sizing: inherit; }

        .m-aside-menu .m-menu__nav > .m-menu__item {
          position: relative;
          margin: 0; }

        .m-aside-menu .m-menu__nav .m-menu__item {
          display: block;
          float: none;
          height: auto;
          padding: 0; }

        .m-aside-menu .m-menu__nav .m-menu__submenu {
          display: block;
          float: none;
          margin: 0;
          padding: 0; }

        .m-aside-menu .m-menu__nav > .m-menu__item .m-menu__submenu .m-menu__item > .m-menu__heading .m-menu__link-bullet, .m-aside-menu .m-menu__nav > .m-menu__item .m-menu__submenu .m-menu__item > .m-menu__link .m-menu__link-bullet {
          vertical-align: middle;
          text-align: left;
          width: 20px; }

        .m-aside-menu .m-menu__nav .m-menu__item > .m-menu__heading .m-menu__link-bullet, .m-aside-menu .m-menu__nav .m-menu__item > .m-menu__link .m-menu__link-bullet {
          display: table-cell;
          height: 100%;
          vertical-align: middle;
          line-height: 0; }

        .mat-drawer {
          min-width: 4vw !important; }

        .m-aside-left.minimize {
          -webkit-transition: all 0.3s ease;
          transition: all 0.3s ease;
          width: 70px;
          padding-left: 0;
          padding-right: 0; }

        .mat-sidenav {
          -webkit-transition: all 0.3s ease;
          transition: all 0.3s ease;
          width: 255px; }
      `],
      animations: [
        slideToRight()
      ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer2, },
{type: ElementRef, },
{type: Router, },
{type: ActivatedRoute, },
{type: MenuService, },
{type: LayoutService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'nav': [{ type: Input },],
'lazyLoadModule': [{ type: Input },],
'navFromRouter': [{ type: Input },],
'lazyLoadPath': [{ type: Input },],
'pageTitle': [{ type: Output },],
'opened': [{ type: Input },],
'toggle': [{ type: Output },],
};
}

function SidenavComponent_tsickle_Closure_declarations() {
/** @type {?} */
SidenavComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SidenavComponent.ctorParameters;
/** @type {?} */
SidenavComponent.propDecorators;
/** @type {?} */
SidenavComponent.prototype.nav;
/** @type {?} */
SidenavComponent.prototype.lazyLoadModule;
/** @type {?} */
SidenavComponent.prototype.navFromRouter;
/** @type {?} */
SidenavComponent.prototype.lazyLoadPath;
/** @type {?} */
SidenavComponent.prototype.pageTitle;
/** @type {?} */
SidenavComponent.prototype.moduleConfig;
/** @type {?} */
SidenavComponent.prototype.opened;
/** @type {?} */
SidenavComponent.prototype.sidenavClass;
/** @type {?} */
SidenavComponent.prototype.render;
/** @type {?} */
SidenavComponent.prototype.ref;
/** @type {?} */
SidenavComponent.prototype.router;
/** @type {?} */
SidenavComponent.prototype.activeRoute;
/** @type {?} */
SidenavComponent.prototype.menuService;
/** @type {?} */
SidenavComponent.prototype.layoutService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
